import { render, staticRenderFns } from "./certificationInfo.vue?vue&type=template&id=374c97b4"
import script from "./certificationInfo.vue?vue&type=script&lang=js"
export * from "./certificationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports